module.exports = __webpack_public_path__ + "static/media/asset_up_arrow.df78353f.png";